function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
DmsPushAPIProvider.$inject = ["selectedDealersInjectorProvider"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import angular from 'angular';
import { defaultsDeep } from 'lodash';
import swaggerDefinition from './swagger-definition-dmspush';
import { OpportunitiesModule } from '../core/opportunities.module';

// AngularJS seems to require we load selectedDealersInjector first, or else
// injecting its provider fails with an error.
import './selected-dealers-injector.service';

//NOTES:
//STEP 1:  add this to the app.config
//$httpProvider.defaults.useXDomain = true;

//STEP 2:  read this article
//http://stackoverflow.com/questions/21455045/angularjs-http-cors-and-http-authentication

OpportunitiesModule.provider('dmsPushApi', DmsPushAPIProvider);
function DmsPushAPIProvider(selectedDealersInjectorProvider) {
  "ngInject";

  var dmsPushApi = {
    config: {}
  };
  return {
    configure: function configure(_ref) {
      var url = _ref.url;
      dmsPushApi.config.domain = url;
      selectedDealersInjectorProvider.addUrl(url);
    },
    $get: ["$http", function DmsPushAPI($http) {
      "ngInject";

      loadAPI();
      return dmsPushApi;
      function loadAPI() {
        for (var path in swaggerDefinition.paths) {
          var clients = CreateClients(swaggerDefinition, path);

          // This function name isn't great, I'd love to either find
          // a better name for it, split it up into smaller,
          // grokkable functions, or replace it.
          // coreApi = apply(coreApi, clients);
          defaultsDeep(dmsPushApi, clients);
        }
        dmsPushApi.swaggerDefinition = swaggerDefinition;
      }
      function CreateClients(swaggerDefinition, path) {
        var pathSplit = path.split("/");
        var controller;
        var child = controller = {};
        for (var i = 0; i < pathSplit.length; i++) {
          var name = pathSplit[i];
          var isIgnored = name == "";
          if (!isIgnored) {
            if (child[name] == null) child[name] = {};
            child = child[name];
            var isEndpoint = i == pathSplit.length - 1;
            if (isEndpoint) {
              var httpVerbs = swaggerDefinition.paths[path];
              for (var httpVerb in httpVerbs) {
                var upperCaseVerb = httpVerb.toUpperCase();
                switch (upperCaseVerb) {
                  case "GET":
                    child.GET = function (urlParams, httpOptions) {
                      return $http(_objectSpread({
                        method: "GET",
                        url: aggregateUrl(this.GET.config.httpPath, urlParams),
                        params: urlParams,
                        withCredentials: true
                      }, httpOptions));
                    };
                    break;
                  case "POST":
                    child.POST = function (body, urlParams, httpOptions) {
                      return $http(_objectSpread({
                        method: "POST",
                        url: aggregateUrl(this.POST.config.httpPath, urlParams),
                        params: urlParams,
                        data: body,
                        withCredentials: true,
                        headers: _objectSpread({
                          'Content-Type': 'application/json'
                        }, httpOptions && httpOptions.headers)
                      }, httpOptions));
                    };
                    break;
                  case "PUT":
                    child.PUT = function (body, urlParams, httpOptions) {
                      return $http(_objectSpread({
                        method: "PUT",
                        url: aggregateUrl(this.PUT.config.httpPath, urlParams),
                        params: urlParams,
                        data: body,
                        withCredentials: true,
                        headers: _objectSpread({
                          'Content-Type': 'application/json'
                        }, httpOptions && httpOptions.headers)
                      }, httpOptions));
                    };
                    break;
                  case "DELETE":
                    child.DELETE = function (urlParams, httpOptions) {
                      return $http(_objectSpread({
                        method: "DELETE",
                        url: aggregateUrl(this.DELETE.config.httpPath, urlParams),
                        params: urlParams,
                        withCredentials: true,
                        headers: _objectSpread({
                          'Content-Type': 'application/json'
                        }, httpOptions && httpOptions.headers)
                      }, httpOptions));
                    };
                    break;
                  case "PATCH":
                    child.PATCH = function (body, urlParams, httpOptions) {
                      return $http(_objectSpread({
                        method: "PATCH",
                        url: aggregateUrl(this.PATCH.config.httpPath, urlParams),
                        params: urlParams,
                        data: body,
                        withCredentials: true,
                        headers: _objectSpread({
                          'Content-Type': 'application/json'
                        }, httpOptions && httpOptions.headers)
                      }, httpOptions));
                    };
                    break;
                  default:
                    console.Write("HTTP verb: '" + upperCaseVerb + "' is not supported");
                    break;
                }
                child[upperCaseVerb].config = {
                  httpVerb: httpVerb,
                  httpPath: dmsPushApi.config.domain + path,
                  swaggerInfo: httpVerbs[httpVerb]
                };
              }
            }
          }
        }
        return controller;
      }
      function aggregateUrl(url, params) {
        if (params != null) {
          for (var param in params) {
            url = url.replace("{" + param + "}", encodeURI(params[param]));
          }
        }
        return url;
      }
    }]
  };
}